/** @jsxImportSource @emotion/react */

import PromotionBanner from "assets/desktop/images/promotion-banner.jpeg";
import Container from "components/common/Container";
import HelmetCustom from "components/common/HelmetCustom";
import Loading from "components/common/Loading";
import MDrawer from "components/mobile/MDrawer";
import { PATH } from "constants/path";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { isMobile } from "router";
import { selectPromotionList } from "store/retrive";
import { getPromotionList } from "store/retrive/retrive.thunk";
import { AppDispatch } from "types";
import { Promotion } from "types/retrive";

import { PromotionPageStyle } from "./index.style";
import MPromotionDetail from "./MPromotionDetail";
import PromotionRender from "./PromotionRender";

const PromotionPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { isLoading, data } = useSelector(selectPromotionList);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [isOpenDraw, setIsOpenDraw] = useState<boolean>(true);
  const [promotionSelected, setPromotionSelected] = useState<Promotion | null>(
    null,
  );

  const handleCloseDraw = () => {
    setIsOpenDraw(false);
    navigate(-1);
    setPromotionSelected(null);
  };

  const handleShowDrawDetail = (promotion: Promotion) => {
    if (!promotion.link) {
      setPromotionSelected(promotion);
    }
  };

  const handleBack = () => {
    setPromotionSelected(null);
  };

  useEffect(() => {
    if (data) {
      return;
    }
    dispatch(getPromotionList());
  }, []);

  const isEvent = pathname === PATH.User.Event;
  return (
    <div css={PromotionPageStyle.self}>
      {!isMobile && !isEvent && (
        <div css={PromotionPageStyle.banner}>
          <img src={PromotionBanner} alt="" />
        </div>
      )}
      {!isMobile && isEvent && (
        <div css={PromotionPageStyle.headerEvent}>
          <div className="title">
            <span>Khu sự kiện</span>
          </div>
        </div>
      )}
      <div css={PromotionPageStyle.wrapper(isEvent)}>
        <HelmetCustom title="Promotion" />
        {isLoading ? (
          <Loading height={500} center />
        ) : (
          <Container>
            {isMobile ? (
              // mobile
              <MDrawer
                title={isEvent ? "Khu sự kiện" : "Khu vực ưu đãi"}
                isOpen={isOpenDraw}
                onClose={handleCloseDraw}
                isBack={!!promotionSelected}
                onBack={handleBack}
              >
                {promotionSelected ? (
                  <MPromotionDetail
                    isSubcribe={promotionSelected.button}
                    content={promotionSelected.content}
                  />
                ) : (
                  <Fragment>
                    <PromotionRender
                      onClick={(item) => handleShowDrawDetail(item)}
                      data={data}
                    />
                  </Fragment>
                )}
              </MDrawer>
            ) : (
              // desktop
              <Fragment>
                <PromotionRender data={data} />
              </Fragment>
            )}
          </Container>
        )}
      </div>
    </div>
  );
};

export default PromotionPage;
